// @ts-strict

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bannerSizeFilter'
})
export class BannerSizeFilterPipe implements PipeTransform {
  transform(
    unfilteredBannersList: Array<{
      id: number;
      size: string;
      width: number;
      height: number;
    }>,
    chosenWidth: number,
    chosenHeight: number
  ): Array<{ id: number; size: string; width: number; height: number }> {
    if (chosenWidth === 0 && chosenHeight === 0) {
      return unfilteredBannersList;
    } else {
      const filteredBannersList: Array<{
        id: number;
        size: string;
        width: number;
        height: number;
      }> = [];
      unfilteredBannersList.forEach(item => {
        if (item.width === chosenWidth && item.height === chosenHeight) {
          filteredBannersList.push(item);
        }
      });
      return filteredBannersList;
    }
  }
}
